import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { tokens } from '../../theme';

// Page title in the style of the home screen: small teal overline, large title, one line of
// explanation and the page's main actions on the right.
const PageHeader = ({ overline, title, subtitle, actions, mb = 3 }) => (
  <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" alignItems={{ xs: 'flex-start', md: 'flex-end' }}
    spacing={2} sx={{ mb }}>
    <Box sx={{ minWidth: 0 }}>
      {overline && <Typography variant="overline" sx={{ color: tokens.primaryDark }}>{overline}</Typography>}
      <Typography variant="h1" component="h1">{title}</Typography>
      {subtitle && (
        <Typography color="text.secondary" sx={{ mt: 0.75, maxWidth: 760 }}>{subtitle}</Typography>
      )}
    </Box>
    {actions && (
      <Stack direction="row" spacing={1.25} alignItems="center" flexWrap="wrap" useFlexGap sx={{ flexShrink: 0 }}>
        {actions}
      </Stack>
    )}
  </Stack>
);

export default PageHeader;
